// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"H8-z"};